import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
    const frontCode = process.env.VUE_APP_BRANCH;
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
  
    locales.keys().forEach(key => {
      const matched = key.match(/\.\/([A-Za-z0-9-_]+)\/([a-z]{2})\.json$/i);
      if (!matched) return;
  
      const folder = matched[1]; // CETE_2025, OUTRA_FRENTE, etc.
      const locale = matched[2]; // pt, en, etc.
  
      if (folder === frontCode) {
        messages[locale] = locales(key);
      }
    });
    return messages;
}

const savedLanguage = JSON.parse(localStorage.getItem('language')) || { sigla: 'pt' };

const i18n = createI18n({
    locale: savedLanguage.sigla, // Idioma padrão
    fallbackLocale: 'pt', // Idioma de fallback
    messages: loadLocaleMessages(),
});
export default i18n;